import { ArenaOpsUsdtSchema } from "./arena-ops-filters.dto";
import { z } from "zod";

/**
 * T2 — the same funnel split by grant source and face-value denomination.
 *
 * Every column here sums to its namesake on the lifecycle response, because
 * both come from ONE backend aggregate — lifecycle sums the rows this panel
 * renders. `faceHeldUsdt` and `faceExpiredUsdt` are carried for exactly that
 * reason: without them an operator could not reproduce the lifecycle tile by
 * adding up this table, which is the first arithmetic they will try.
 */
export const ArenaOpsTicketsBySourceRowSchema = z.object({
  source: z.string(),
  faceValueUsdt: ArenaOpsUsdtSchema,
  granted: z.number().int(),
  active: z.number().int(),
  used: z.number().int(),
  expired: z.number().int(),
  faceIssuedUsdt: ArenaOpsUsdtSchema,
  faceSpentUsdt: ArenaOpsUsdtSchema,
  faceHeldUsdt: ArenaOpsUsdtSchema,
  faceExpiredUsdt: ArenaOpsUsdtSchema,
});

export const ArenaOpsTicketsBySourceResponseSchema = z.object({
  rows: z.array(ArenaOpsTicketsBySourceRowSchema),
});
export type ArenaOpsTicketsBySourceResponse = z.infer<typeof ArenaOpsTicketsBySourceResponseSchema>;
